<template>

    <div class="body">
        <div class="body__container">
            <h2 class="text-xlBold">{{ $t('cleaning_sort_by') }}</h2>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('cleaning_sort_open_rate') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.MOST_OPEN)">
                <img :src="isSortMostOpen ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortMostOpen, 'color__moon': !isSortMostOpen}">{{ $t('cleaning_sort_more_open') }}</p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.LEAST_OPEN)">
                <img :src="isSortLeastOpen ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortLeastOpen, 'color__moon': !isSortLeastOpen}">{{ $t('cleaning_sort_less_open') }}</p>
            </div>
        </div>

        <div class="body__container">
            <p class="text-lSemibold">{{ $t('cleaning_nb_mail_received') }}</p>
            <div class="body__row mt__12" @click="clickSort(ENUM.NEWSLETTERS.SORT.ASCENDING)">
                <img :src="isSortAscending ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortAscending, 'color__moon': !isSortAscending}">
                    {{ $t('cleaning_sort_ascending_order') }}
                </p>
            </div>
            <div class="body__row mt__10" @click="clickSort(ENUM.NEWSLETTERS.SORT.DESCENDING)">
                <img :src="isSortDescending ? checkTrue : checkFalse"
                     class="body__row__img">
                <p class="text-lMedium" :class="{'color__charcoal': isSortDescending, 'color__moon': !isSortDescending}">{{ $t('cleaning_sort_descending_order') }}</p>
            </div>
        </div>

        <div class="body__container">
            <button class="body__btn text-lSemibold color__white" @click="valid">{{ $t('cleaning_validate_sort') }}
            </button>
        </div>

    </div>

</template>

<script>
import Vuex from 'vuex'

import ENUM from '@/assets/ENUM'

import Tag from '@/modules/tag'

export default {

    name: 'sort-body',

    computed: {

        ...Vuex.mapGetters(['newslettersSort']),

        ENUM() {
            return ENUM
        },

        isSortMostOpen() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.MOST_OPEN
        },

        isSortLeastOpen() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.LEAST_OPEN
        },

        isSortAscending() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.ASCENDING
        },

        isSortDescending() {
            return this.newslettersSort === ENUM.NEWSLETTERS.SORT.DESCENDING
        }
    },

    data() {
        return {
            sort: '',
            checkTrue: '/img/newsletters-v2/check-list-on.svg',
            checkFalse: '/img/newsletters-v2/check-list-off.svg',
        }
    },

    methods: {

        ...Vuex.mapActions(['updateNewslettersSort']),

        valid() {
            Tag.clickGA(this, 'validate')
            this.$emit('close')
        },

        clickSort(sortBy) {

            switch (sortBy) {
                case ENUM.NEWSLETTERS.SORT.MOST_OPEN:
                    Tag.clickGA(this, 'order_open_down')
                    break
                case ENUM.NEWSLETTERS.SORT.LEAST_OPEN:
                    Tag.clickGA(this, 'order_open_up')
                    break
                case ENUM.NEWSLETTERS.SORT.ASCENDING:
                    Tag.clickGA(this, 'order_email_up')
                    break
                case ENUM.NEWSLETTERS.SORT.DESCENDING:
                    Tag.clickGA(this, 'order_email_down')
                    break
            }

            this.updateNewslettersSort(sortBy)
        }
    }
}
</script>

<style lang="scss" scoped>

.body {
    width: 100%;

    &__container {
        width: 100%;
        padding: 16px;
        display: flex;
        flex-direction: column;
        text-align: start;
        border-bottom: 1px solid $divider;
    }

    &__row {
        display: flex;
        flex-direction: row;
        align-items: center;
        cursor: pointer;

        &__img {
            width: 20px;
            object-fit: contain;
            margin-right: 8px;

            &:lang(ar-sa) {
                margin-right: 0;
                margin-left: 8px;
            }
        }
    }

    &__btn {
        padding: 17px;
        background-color: $midnight;
        border-radius: 72px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
    }
}
</style>
